/* VIXEL wordmark — placeholder mark (clean SVG) per il branding parent business.
   L'utente può sostituire questo SVG con il logo Vixel originale (drop-in).
*/
import React from "react";

export default function VixelMark({ className = "", height = 18 }) {
  return (
    <svg
      className={className}
      width={height * 3.4}
      height={height}
      viewBox="0 0 170 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Vixel"
    >
      <defs>
        <linearGradient id="vixel-g" x1="0" y1="0" x2="170" y2="50" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FF7A1A" />
          <stop offset="0.55" stopColor="#7B61FF" />
          <stop offset="1" stopColor="#0EA5E9" />
        </linearGradient>
      </defs>
      {/* Mark — angular V with cut */}
      <path
        d="M6 8 L18 8 L26 32 L34 8 L46 8 L30 44 L22 44 L6 8 Z"
        fill="url(#vixel-g)"
      />
      {/* Wordmark */}
      <text
        x="56"
        y="36"
        fontFamily="ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
        fontWeight="800"
        fontSize="30"
        letterSpacing="2"
        fill="currentColor"
      >
        IXEL
      </text>
    </svg>
  );
}
